// src/pages/Confidentialite.js
import React from "react";
import "../index.css";

export default function Confidentialite() {
  return (
    <main className="legal-page">
      <header className="legal-hero">
        <h1>Politique de confidentialité</h1>
        <p>Protection des données personnelles — Maxime H</p>
      </header>

      <div className="legal-stack">
        <section className="legal-card">
          <h2>1 — Responsable du traitement</h2>
          <p>
            <strong>Maxime HUYLEBROECK</strong> (EI)<br />
            Adresse professionnelle : 23 allée René Peters, 54510 Tomblaine — France<br />
            Email : <a href="mailto:contact@maximeh.fr">contact@maximeh.fr</a>
          </p>
        </section>

        <section className="legal-card">
          <h2>2 — Données collectées</h2>
          <ul>
            <li>Nom et prénom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone</li>
            <li>Contenu du message via le formulaire de contact</li>
            <li>Données de navigation anonymes (statistiques de visite)</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>3 — Finalités du traitement</h2>
          <ul>
            <li>Répondre aux demandes envoyées via le formulaire de contact</li>
            <li>Établir des devis et assurer le suivi des prestations</li>
            <li>Améliorer l’expérience utilisateur et le contenu du site</li>
            <li>Réaliser des statistiques de fréquentation anonymes</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>4 — Base légale</h2>
          <ul>
            <li>Consentement (formulaire de contact)</li>
            <li>Intérêt légitime (gestion de l’activité)</li>
            <li>Mesures précontractuelles (demande de devis)</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>5 — Durée de conservation</h2>
          <ul>
            <li>Données de contact : 3 ans après le dernier échange</li>
            <li>Données liées à une prestation : durée légale de conservation comptable</li>
            <li>Données de navigation : selon les outils de mesure utilisés</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>6 — Destinataires</h2>
          <p>
            Les données sont destinées uniquement à <strong>Maxime HUYLEBROECK</strong>.
            Elles ne sont ni vendues, ni louées, ni transmises à des tiers, sauf obligation légale.
          </p>
        </section>

        <section className="legal-card">
          <h2>7 — Cookies / mesure d’audience</h2>
          <p>
            Le site peut utiliser des outils de mesure d’audience (ex : Google Analytics) afin d’analyser la
            fréquentation et améliorer l’expérience. Les données sont utilisées à des fins statistiques.
          </p>
        </section>

        <section className="legal-card">
          <h2>8 — Vos droits</h2>
          <p>
            Conformément au RGPD, vous disposez d’un droit d’accès, rectification, effacement, opposition,
            limitation et portabilité. Pour exercer vos droits :{" "}
            <a href="mailto:contact@maximeh.fr">contact@maximeh.fr</a>
          </p>
        </section>

        <section className="legal-card">
          <h2>9 — Réclamation</h2>
          <p>
            En cas de litige, vous pouvez saisir la CNIL :{" "}
            <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">www.cnil.fr</a>
          </p>
        </section>
      </div>
    </main>
  );
}